"use strict";

function _typeof(obj) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (obj) { return typeof obj; } : function (obj) { return obj && "function" == typeof Symbol && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; }, _typeof(obj); }

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _react = _interopRequireWildcard(require("react"));

var _scss = require("@scss");

var _Collapse = _interopRequireDefault(require("@components/Collapse"));

var _Link = _interopRequireDefault(require("Link"));

var _Icon = _interopRequireDefault(require("@components/Icon"));

var _stylesModule = _interopRequireDefault(require("./styles.module.scss"));

var _excluded = ["items", "dropdownOpen", "childrenReplace"],
    _excluded2 = ["items", "childrenReplace"];

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }

function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { _defineProperty(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { var _i = arr == null ? null : typeof Symbol !== "undefined" && arr[Symbol.iterator] || arr["@@iterator"]; if (_i == null) return; var _arr = []; var _n = true; var _d = false; var _s, _e; try { for (_i = _i.call(arr); !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Navigation = /*#__PURE__*/(0, _react.memo)(function Navigation(_ref) {
  var _ref$items = _ref.items,
      items = _ref$items === void 0 ? [] : _ref$items,
      align = _ref.align,
      dropdownIcon = _ref.dropdownIcon,
      classes = _ref.classes,
      onWrapperMouseEnter = _ref.onWrapperMouseEnter,
      onWrapperMouseLeave = _ref.onWrapperMouseLeave,
      _onMouseEnter = _ref.onMouseEnter,
      _onMouseLeave = _ref.onMouseLeave,
      _onClick = _ref.onClick;

  var _useState = (0, _react.useState)(null),
      _useState2 = _slicedToArray(_useState, 2),
      dropdownShown = _useState2[0],
      setDropdownShown = _useState2[1];

  var onClickLink = (0, _react.useCallback)(function (event, linkProps, items, index) {
    if (dropdownShown === index) {
      setDropdownShown(null);
      event.preventDefault();
    } else if (items !== null && items !== void 0 && items.length) {
      setDropdownShown(index);
      event.preventDefault();
    }

    if (linkProps.onClick) {
      linkProps.onClick(event);
    }
  }, [dropdownShown, setDropdownShown]);
  (0, _react.useEffect)(function () {
    var index = items.findIndex(function (item) {
      var _item$items;

      return item.active || ((_item$items = item.items) === null || _item$items === void 0 ? void 0 : _item$items.find(function (subitem) {
        return subitem.active;
      }));
    });

    if (index >= 0) {
      setDropdownShown(index);
    }
  }, [items, setDropdownShown]);
  return /*#__PURE__*/_react["default"].createElement("ul", _extends({}, !!onWrapperMouseEnter && {
    onMouseEnter: onWrapperMouseEnter
  }, !!onWrapperMouseLeave && {
    onMouseLeave: onWrapperMouseLeave
  }, {
    className: (0, _scss.cls)('list-unstyled', _stylesModule["default"].wrapper, classes === null || classes === void 0 ? void 0 : classes.wrapper)
  }), items === null || items === void 0 ? void 0 : items.map(function (_ref2, i) {
    var _ref2$items = _ref2.items,
        items = _ref2$items === void 0 ? [] : _ref2$items,
        dropdownOpen = _ref2.dropdownOpen,
        childrenReplace = _ref2.childrenReplace,
        linkProps = _objectWithoutProperties(_ref2, _excluded);

    return /*#__PURE__*/_react["default"].createElement("li", _extends({
      key: i
    }, (classes === null || classes === void 0 ? void 0 : classes.listItem) && {
      className: classes.listItem
    }, !!(items !== null && items !== void 0 && items.length) && dropdownIcon && {
      'data-open': i === dropdownShown || dropdownOpen
    }, !!(items !== null && items !== void 0 && items.length) && dropdownIcon && {
      'data-hover': dropdownOpen
    }), childrenReplace ? childrenReplace : /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({}, linkProps, {
      onClick: function onClick(e) {
        onClickLink(e, linkProps, items, i);
      }
    }, (classes === null || classes === void 0 ? void 0 : classes.item) && {
      classes: classes.item
    }, !!_onMouseEnter && {
      onMouseEnter: function onMouseEnter() {
        _onMouseEnter(_objectSpread({
          items: items
        }, linkProps));
      }
    }, !!_onMouseLeave && {
      onMouseLeave: function onMouseLeave() {
        _onMouseLeave(_objectSpread({
          items: items
        }, linkProps));
      }
    }), /*#__PURE__*/_react["default"].createElement("span", null, linkProps.children), items !== null && items !== void 0 && items.length && dropdownIcon ? /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
      classes: {
        icon: (0, _scss.cls)(_stylesModule["default"].icon)
      },
      name: dropdownIcon,
      alt: "Open submenu"
    }) : null), (items === null || items === void 0 ? void 0 : items.length) > 0 ? /*#__PURE__*/_react["default"].createElement(_Collapse["default"], {
      theme: {
        collapse: (classes === null || classes === void 0 ? void 0 : classes.dropdown) || '',
        content: (classes === null || classes === void 0 ? void 0 : classes.dropdownContent) || ''
      },
      isOpened: dropdownShown === i
    }, /*#__PURE__*/_react["default"].createElement("ul", {
      className: (0, _scss.cls)('list-unstyled', _stylesModule["default"].wrapper, classes === null || classes === void 0 ? void 0 : classes.dropdownWrapper)
    }, items === null || items === void 0 ? void 0 : items.map(function (_ref3, ii) {
      var items = _ref3.items,
          childrenReplace = _ref3.childrenReplace,
          linkProps = _objectWithoutProperties(_ref3, _excluded2);

      return /*#__PURE__*/_react["default"].createElement("li", _extends({
        key: "".concat(i, "-").concat(ii)
      }, (classes === null || classes === void 0 ? void 0 : classes.dropdownListItem) && {
        className: classes.dropdownListItem
      }), childrenReplace ? childrenReplace : /*#__PURE__*/_react["default"].createElement(_Link["default"], _extends({}, linkProps, {
        onClick: function onClick(e) {
          if (typeof (linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick) === 'function') linkProps === null || linkProps === void 0 ? void 0 : linkProps.onClick(e);
          if (typeof _onClick === 'function') _onClick(e);
        }
      }, (classes === null || classes === void 0 ? void 0 : classes.dropdownItem) && {
        classes: classes.dropdownItem
      })));
    }))) : null);
  }));
});
var _default = Navigation;
exports["default"] = _default;